import React from "react";
import { bool, string } from "prop-types";
import { motion } from "framer-motion";

import ProgressCircle from "./ProgressCircle";
import CheckMark from "./CheckMark";
import CitroenMark from "./CitroenMark";
import HomeMark from "@components/shared/Icons/HomeTDLogo.js";
import Icon from "@components/shared/Icons/Icon";

const ProgressBar = ({
  isComplete,
  isInitialStep,
  isFinalStep,
  progressLineOnCompleteStep = true,
  isHomeTestDrive,
}) => {
  const circleSize = 35;
  const circleDelay = 0.3;
  const circleFillDuration = 0.3;
  const circleDrawDuration = 0.3;
  const checkMarkWidth = 19;
  const checkMarkHeight = 15;
  const checkMarkDelay = 0.6;
  const checkMarkDuration = 0.25;
  const progressLineDelay = 0.9;
  const progressLineDuration = 0.4;

  return (
    <aside className="flex flex-col items-center relative z-10 w-12 shrink-0 grow-0 basis-12">
      {isHomeTestDrive ? (
        <Icon
          className="size-10 relative text-primaryDark"
          icon={<HomeMark />}
        />
      ) : (
        <div className="relative">
          {isInitialStep ? (
            <CitroenMark />
          ) : (
            <>
              <ProgressCircle
                isComplete={isComplete}
                size={circleSize}
                delay={circleDelay}
                fillDruation={circleFillDuration}
                drawDuration={circleDrawDuration}
              />
              <CheckMark
                width={checkMarkWidth}
                height={checkMarkHeight}
                isComplete={isComplete}
                delay={checkMarkDelay}
                duration={checkMarkDuration}
              />
            </>
          )}
        </div>
      )}
      {!isFinalStep && (
        <motion.div
          animate={{
            height: isComplete && progressLineOnCompleteStep ? "100%" : "0%",
          }}
          className="w-0.5 h-full absolute top-0 left-1/2 -translate-x-1/2 bg-primaryOrange -z-1"
          initial={{ height: "0%" }}
          transition={{
            delay: progressLineDelay,
            duration: progressLineDuration,
          }}
        />
      )}
    </aside>
  );
};
ProgressBar.propTypes = {
  isComplete: bool,
  isFinalStep: bool,
  isInitialStep: bool,
  progressBarColor: string,
  progressLineOnCompleteStep: bool,
  isHomeTestDrive: bool,
};

export default ProgressBar;
